<template>
    <!-- Evolution details popup -->
      <div class="vx-row w-full">
        <div class="vx-col w-full ml-3">
          <vx-card>
            <vs-table stripe auto-resize hoverFlat v-if="selectedTopKeywordsSERPComparison" noDataText="">
              <template slot="thead">
                <vs-td class="text-center"></vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td class="text-center" :colspan="selectedTopKeywordsSERPComparison.dates.length || 1">
                  <strong>Position sur Google au :</strong>
                </vs-td>
              </template>

              <template>
                <vs-tr>
                  <vs-td class="text-center"><span>Keyword</span></vs-td>
                  <vs-td><span>Recherches mensuelles</span></vs-td>
                  <vs-td style="background-color: #f8f8f8; width: 2px;"> </vs-td>
                  <vs-td class="text-center" :key="index" v-for="(date, index) of selectedTopKeywordsSERPComparison.dates">
                    <span>{{ date.split('-').reverse().join('/') }}</span>
                  </vs-td>
                </vs-tr>
              </template>

              <template v-for="(row, index) of selectedTopKeywordsSERPComparison.keywords">
                <vs-tr :key="indexLoop+index" v-for="(item, indexLoop) of [1]" class="table_line_small">
                  <vs-td style="color: white; background-color: #0c293d;">
                    <strong>{{ index }}</strong>
                  </vs-td>
                  <vs-td style="color: white; background-color: #0c293d;" class="td_padding_top_bottom_small">
                    <vs-chip><strong>{{ selectedTopKeywordsSERPComparison.keywords_info[index].volume == 0 ? 0 : formatThousandNumb(selectedTopKeywordsSERPComparison.keywords_info[index].volume) }}</strong></vs-chip>
                  </vs-td>
                  <vs-td style="background-color: #f8f8f8; width: 2px;"> </vs-td>
                  <vs-td class="text-center" :key="index" v-for="(date, index) of selectedTopKeywordsSERPComparison.dates" style="color: white; background-color: #0c293d;"></vs-td>
                </vs-tr>
                <vs-tr :key="index+indexTr" v-for="(keyword,indexTr) of row" class="table_line_small">
                  <vs-td v-if="indexTr == index">
                    <strong>{{ indexTr }}</strong>
                  </vs-td>
                  <vs-td v-else>
                    {{ indexTr }}
                  </vs-td>
                  <vs-td>
                    <apexchart
                      height="20"
                      width="100"
                      :options="getTrendOptions(indexTr)"
                      :series="getTrendSeries(keyword)"
                    />
                  </vs-td>
                  <vs-td style="background-color: #f8f8f8; width: 2px;"> </vs-td>
                  <vs-td :key="indexTd" v-for="(rowData, indexTd) of keyword" class="text-center td_padding_top_bottom_small chip_width">
                    <strong v-if="indexTd == (keyword.length - 1)">
                      <vs-chip v-if="rowData > keyword[indexTd-1] && keyword[indexTd-1] == 0" style="color: white; border-radius: 0px;width: 65px;" color="green"><span style="font-size: 1rem;">{{ rowData > 100 ? '100+' : rowData }}</span><vs-icon icon-pack="feather" icon="icon-arrow-up" size="small" color="white" style="font-size: 1rem; height: 0.8rem;"></vs-icon></vs-chip>
                      <vs-chip v-else-if="rowData === 0 && keyword[indexTd-1] == -1" style="color: white; border-radius: 0px;width: 65px;" color="grey">ABS</vs-chip>
                      <vs-chip v-else-if="rowData > keyword[indexTd-1] && keyword[indexTd-1] === -1" style="color: white; border-radius: 0px;width: 65px;" color="grey"><span style="font-size: 1rem;">{{ rowData > 100 ? '100+' : rowData }}</span></vs-chip>
                      <vs-chip v-else-if="rowData > keyword[indexTd-1] && keyword[indexTd-1] != 0" style="color: white; border-radius: 0px;width: 65px;" color="red"><span style="font-size: 1rem;">{{ rowData > 100 ? '100+' : rowData }}</span><vs-icon icon-pack="feather" icon="icon-arrow-down" size="small" color="white" style="font-size: 1rem; height: 0.8rem;"></vs-icon></vs-chip>

                      <vs-chip v-else-if="rowData < keyword[indexTd-1] && rowData === 0" style="border-radius: 0px;width: 65px;" color="grey">ABS</vs-chip>
                      <span v-else-if="rowData < keyword[indexTd-1] && rowData == -1 && isCurrentMonth(selectedTopKeywordsSERPComparison.dates[indexTd])"><vs-icon icon="schedule" size="small" color="primary" /></span>
                      <span v-else-if="rowData < keyword[indexTd-1] && rowData == -1"><vs-icon icon="schedule" size="small" color="primary" /></span>
                      <vs-chip v-else-if="rowData < keyword[indexTd-1] && rowData != 0" style="color: white; border-radius: 0px;width: 65px;" color="green"><span style="font-size: 1rem;">{{ rowData > 100 ? '100+' : rowData }}</span><vs-icon icon-pack="feather" icon="icon-arrow-up" size="small" color="white" style="font-size: 1rem; height: 0.8rem;"></vs-icon></vs-chip>

                      <span v-else-if="rowData === 0">ABS</span>
                      <span v-else-if="rowData == -1 && isCurrentMonth(selectedTopKeywordsSERPComparison.dates[indexTd])"><vs-icon icon="schedule" size="small" color="primary" /></span>
                      <span v-else-if="rowData == -1"> </span>

                      <vs-chip v-else style="border-radius: 0px;width: 65px;"><span style="font-size: 1rem;">{{ rowData > 100 ? '100+' : rowData }}</span> <vs-icon icon-pack="feather" icon="icon-arrow-right" size="small" style="font-size: 1rem; height: 0.8rem;"></vs-icon></vs-chip>
                    </strong>
                    <span v-else>
                      <span v-if="rowData > keyword[indexTd-1] && keyword[indexTd-1] == 0" style="color: green;">{{ rowData > 100 ? '100+' : rowData }}</span>
                      <span v-else-if="rowData === 0 && keyword[indexTd-1] == -1">ABS</span>
                      <span v-else-if="rowData > keyword[indexTd-1] && keyword[indexTd-1] != 0" style="color: red;">{{ rowData > 100 ? '100+' : rowData }}</span>

                      <span v-else-if="rowData < keyword[indexTd-1] && rowData === 0">ABS</span>
                      <span v-else-if="rowData < keyword[indexTd-1] && rowData == -1" style="color: red;"></span>
                      <span v-else-if="rowData < keyword[indexTd-1] && rowData != 0" style="color: green;">{{ rowData > 100 ? '100+' : rowData }}</span>

                      <span v-else-if="rowData === 0">ABS</span>
                      <span v-else-if="rowData == -1"></span>
                      <span v-else>{{ rowData > 100 ? '100+' : rowData }}</span>
                    </span>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "TopKeywordEvolutionTable",
	props: {
		selectedTopKeywordsSERPComparison: {
			type: Object,
			default: null
		},
		competitors: {
			type: Array,
			default: []
		},
		societyColor: {
			type: String,
			default: null
		},
		competitorsColor: {
			type: Array,
			default: []
		},
	},
	mixins: [utilsMixin],
	data(){
		return {
			keyword: []
		};
	},
	methods: {
		isCurrentMonth(date){
			let today = new Date(Date.now());
			if(date.length >= 7){
				return parseInt(date.substring(5, 7)) == today.getMonth() + 1 ? true : false;
			}
			return false;
		},
		getTrendOptions(url){
			let lineColor = [this.societyColor];
			let urlIndex = this.competitors.findIndex(competitor => competitor == url);
			if(urlIndex >= 0){
				lineColor = [this.competitorsColor[urlIndex]];
			}

			let trendOptions = {
				grid: {
					show: false,
					padding: {
						left: 0,
						right: 0
					}
				},
				chart: {
					toolbar: {
						show: false
					},
					sparkline: {
						enabled: true
					}
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: "smooth",
					width: 2.5,
					colors: lineColor
				},
				xaxis: {
					type: "numeric",
					lines: {
						show: false,
					},
					axisBorder: {
						show: false
					},
					labels: {show: false}
				},
				yaxis: [
					{
						reversed: true,
						max: 100,
						min: 1,
						y: 0,
						offsetX: 0,
						offsetY: 0,
						padding: {left: 0, right: 0}
					}
				],
				tooltip: {
					x: {show: false},
					fixed: {
						enabled: true,
						position: "bottom",
					},
				}
			};
			return trendOptions;
		},
		getTrendSeries(dataInput){
			let graphicData = [...dataInput];
			for(let i = 0; i < graphicData.length; i++){
				if(graphicData[i] <= 0){
					graphicData[i] = 100;
				}
			}
			return [{
				name: "Positions",
				data: graphicData
			}];
		},
	}
};
</script>